/**
 * Centralised environment variable access.
 *
 * Never reference import.meta.env directly in feature code. Always go through
 * this module so missing vars fail loudly at startup and all call sites are
 * greppable.
 */

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing required env var ${name}. Check apps/web/.env or your Vercel project settings.`
    );
  }
  return value;
}

export const env = {
  supabaseUrl: required("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required(
    "VITE_SUPABASE_ANON_KEY",
    import.meta.env.VITE_SUPABASE_ANON_KEY
  ),
  sentryDsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  environment: (import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE) as string,
  appUrl: (import.meta.env.VITE_APP_URL ?? "https://whistll.com") as string,
  iosAppUrl: import.meta.env.VITE_IOS_APP_URL as string | undefined,
  androidAppUrl: import.meta.env.VITE_ANDROID_APP_URL as string | undefined,
  /**
   * Stripe publishable key (pk_live_... or pk_test_...). Safe to expose
   * in client-side code per Stripe's docs - the secret key stays in
   * Supabase Edge Function env. Left optional so the build doesn't fail
   * before Stripe is wired up; features that need it should guard with
   * `if (!env.stripePublishableKey) return …`.
   */
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as
    | string
    | undefined,
};
